module.exports = __webpack_public_path__ + "static/media/back10.4b68c4ce.jpg";